import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { TechnologiePage } from "@/pages/technologie";

export const Route = createFileRoute("/$lang/technology")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/technologie",
      title: t("technologie.title"),
      description: t("technologie.description"),
    });
  },
  component: TechnologiePage,
});
